import React, { useState } from 'react';
import KeyButton from './KeyButton';

const SHORTCUT_TIP_STORAGE_KEY = 'assessmentKeyboardShortcutTipDismissed';

const UP = '↑';
const LEFT = '←';
const RIGHT = '→';

// Arrow-key cluster: Back (Up) centered on top, Incorrect (Left) and Correct
// (Right) on the bottom row — laid out like the arrow keys on a keyboard, so
// the on-screen buttons mirror the keyboard shortcuts. Buttons show only the
// arrow glyph; hovering reveals the label.
function AssessmentResponseControls({
  onBack,
  onIncorrect,
  onCorrect,
  backDisabled = false,
  responseDisabled = false,
  itemLabel = 'item'
}) {
  const [showShortcutTip, setShowShortcutTip] = useState(() => {
    try {
      return window.localStorage.getItem(SHORTCUT_TIP_STORAGE_KEY) !== 'true';
    } catch (err) {
      return true;
    }
  });

  const dismissShortcutTip = () => {
    try {
      window.localStorage.setItem(SHORTCUT_TIP_STORAGE_KEY, 'true');
    } catch (err) {
      // Ignore storage failures; the tip can still be dismissed for this render.
    }
    setShowShortcutTip(false);
  };

  return (
    <div style={{ flex: '0 0 auto', paddingBottom: '20px' }}>
      <div
        className="response-buttons"
        data-tour="assess-response-controls"
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 72px)',
          gap: '10px',
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: '10px',
        }}
      >
        {/* Row 1: empty · Back(Up) · empty */}
        <span />
        <KeyButton
          glyph={UP}
          tooltip="Back"
          variant="neutral"
          onClick={onBack}
          disabled={backDisabled}
          ariaLabel={`Go back to the previous ${itemLabel}. Shortcut: Up Arrow.`}
        />
        <span />

        {/* Row 2: Incorrect(Left) · empty (where Down would be) · Correct(Right) */}
        <KeyButton
          glyph={LEFT}
          tooltip="Incorrect"
          variant="incorrect"
          onClick={onIncorrect}
          disabled={responseDisabled}
          ariaLabel={`Mark the current ${itemLabel} incorrect. Shortcut: Left Arrow.`}
        />
        <span />
        <KeyButton
          glyph={RIGHT}
          tooltip="Correct"
          variant="correct"
          onClick={onCorrect}
          disabled={responseDisabled}
          ariaLabel={`Mark the current ${itemLabel} correct. Shortcut: Right Arrow.`}
        />
      </div>

      {showShortcutTip && (
        <div
          role="note"
          style={{
            margin: '14px auto 0',
            maxWidth: '520px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '10px',
            padding: '8px 12px',
            borderRadius: '8px',
            border: '1px solid #bfdbfe',
            background: '#eff6ff',
            color: '#1e3a8a',
            fontSize: '0.9rem',
            fontWeight: 700,
            textAlign: 'center'
          }}
        >
          <span>
            Keyboard shortcut: {RIGHT} Correct, {LEFT} Incorrect, {UP} Back
          </span>
          <button
            type="button"
            onClick={dismissShortcutTip}
            aria-label="Dismiss keyboard shortcut tip"
            style={{
              flex: '0 0 auto',
              padding: '3px 8px',
              borderRadius: '6px',
              border: '1px solid #93c5fd',
              background: '#ffffff',
              color: '#1d4ed8',
              fontSize: '0.8rem',
              fontWeight: 800,
              cursor: 'pointer'
            }}
          >
            Dismiss
          </button>
        </div>
      )}
    </div>
  );
}

export default AssessmentResponseControls;
